export default {
  title: 'Erreur',
  error: 'Désolé, une erreur est survenue.',
};
